import styled from "styled-components";
import { colors } from "@/theme";

export const ProductItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 14px;
  padding: 16px 12px 12px 12px;
`;

export const ProductItemImageContainer = styled.div`
  display: flex;
  width: 183px;
  height: 160px;
  padding: 4px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  border-radius: 12px;
  border: 1px solid ${colors.neutralGrey300};
  margin-bottom: 16px;

  & img {
    width: 120px;
    height: 120px;
    flex-shrink: 0;
    object-fit: contain;
  }
`;

export const ProductItemTitleAndPrice = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
`;

export const ProductItemSkuAndCoop = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
`;

export const ProductItemTitle = styled.div`
  color: ${colors.black};
  font-family: "PF DIN Text Pro";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
`;

export const ProductItemPrice = styled.div`
  color: ${colors.black};
  font-family: "PF DIN Text Pro";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
`;

export const ProductItemSku = styled.div``;

export const ProductItemSkuLabel = styled.span`
  color: ${colors.black};
  font-family: "PF DIN Text Pro";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

export const ProductItemSkuValue = styled.span`
  color: ${colors.black};
  font-family: "PF DIN Text Pro";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

export const ProductItemCoop = styled.div``;

export const ProductItemCoopLabel = styled.span`
  color: ${colors.fieldTextHelper};
  font-family: "PF DIN Text Pro";
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  text-transform: uppercase;
`;

export const ProductItemCoopValue = styled.span`
  color: ${colors.black};
  font-family: "PF DIN Text Pro";
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  text-transform: uppercase;
`;
